// src/pages/Iletisim.jsx
import React from "react";

const Iletisim = () => {
  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <h1 style={styles.title}>İLETİŞİM</h1>

        <div style={styles.content}>
          <div style={styles.infoSection}>
            <h2 style={styles.heading}>Bize Ulaşın</h2>
            
            <div style={styles.contactInfo}>
              <div style={styles.contactItem}>
                <h3 style={styles.contactTitle}>Adres</h3>
                <p style={styles.contactText}>
                  Göztepe Mahallesi, Mithatpaşa Caddesi, No:856/1B<br />
                  Konak, İzmir [Posta Kodu: 35290]
                </p>
              </div>

              <div style={styles.contactItem}>
                <h3 style={styles.contactTitle}>Ünvan</h3>
                <p style={styles.contactText}>
                  Von Dijital Hizmetler Pazarlama ve Ticaret LTD. ŞTİ.
                </p>
              </div>

              <div style={styles.contactItem}>
                <h3 style={styles.contactTitle}>Vergi Dairesi</h3>
                <p style={styles.contactText}>
                  Konak<br />
                </p>
              </div>

              <div style={styles.contactItem}>
                <h3 style={styles.contactTitle}>Elektronik İletişim</h3>
                <p style={styles.contactText}>
                  <strong>E-posta:</strong><br />
                  <a href="mailto:info@vondigital.com.tr" style={styles.link}>
                    info@vondigital.com.tr
                  </a><br />
                </p>
              </div>

              <div style={styles.contactItem}>
                <h3 style={styles.contactTitle}>Çalışma Saatleri</h3>
                <p style={styles.contactText}>
                  Pazartesi - Cuma: 09:00 - 18:00<br />
                  Cumartesi: 10:00 - 16:00<br />
                  Pazar: Kapalı
                </p>
              </div>
            </div>
          </div>

          <div style={styles.mapSection}>
          <h2 style={styles.heading}>Konumumuz</h2>
          <div style={styles.mapContainer}>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3126.715855970198!2d27.09137277572398!3d38.401818471834034!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14bbdeb2d8fc2009%3A0x8ba0188060f755e!2sG%C3%B6ztepe%2C%20Mithatpa%C5%9Fa%20Cd.%20856-1%20B%2C%2035290%20Konak%2F%C4%B0zmir!5e0!3m2!1str!2str!4v1762873890167!5m2!1str!2str"
              width="100%"
              height="450"
              style={{ border: 0, borderRadius: "12px" }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Google Maps - Şirket Konumu"
            ></iframe>
          </div>
        </div>

        </div>

        <section style={styles.section}>
          <h2 style={styles.heading}>Hızlı İletişim Formu</h2>
          <div style={styles.quickContact}>
            <p style={styles.text}>
              Size daha hızlı dönüş yapabilmemiz için aşağıdaki iletişim bilgilerimizden 
              bize ulaşabilir veya e-posta gönderebilirsiniz.
            </p>
            <div style={styles.contactButtons}>
              <a href="mailto:info@vondigital.com.tr" style={styles.contactButton}>
                E-posta Gönder
              </a>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

const styles = {
  page: {
    backgroundColor: "#f7f7f7",
    minHeight: "100vh",
    padding: "60px 20px",
    display: "flex",
    justifyContent: "center",
  },
  container: {
    maxWidth: "900px",
    backgroundColor: "#fff",
    borderRadius: "12px",
    padding: "40px 30px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
    lineHeight: "1.7",
  },
  title: {
    fontSize: "24px",
    fontWeight: "700",
    textAlign: "center",
    marginBottom: "30px",
    color: "#222",
  },
  content: {
    display: "flex",
    gap: "30px",
    marginBottom: "30px",
  },
  infoSection: {
    flex: 1,
  },
  mapSection: {
    flex: 1,
  },
  section: {
    marginBottom: "25px",
  },
  heading: {
    fontSize: "18px",
    fontWeight: "600",
    color: "#333",
    marginBottom: "15px",
    borderBottom: "2px solid #f0f0f0",
    paddingBottom: "8px",
  },
  contactInfo: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  contactItem: {
    paddingBottom: "15px",
    borderBottom: "1px solid #f0f0f0",
  },
  contactTitle: {
    fontSize: "16px",
    fontWeight: "600",
    color: "#001e78",
    marginBottom: "8px",
  },
  contactText: {
    fontSize: "14px",
    color: "#555",
    lineHeight: "1.6",
  },
  text: {
    fontSize: "14px",
    color: "#555",
    marginBottom: "10px",
  },
  link: {
    color: "#0056b3",
    textDecoration: "none",
  },
  mapContainer: {
    width: "100%",
    height: "400px",
    borderRadius: "8px",
    overflow: "hidden",
  },
  mapPlaceholder: {
    width: "100%",
    height: "100%",
    backgroundColor: "#f8f9fa",
    border: "2px dashed #dee2e6",
    borderRadius: "8px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px",
  },
  mapText: {
    fontSize: "18px",
    fontWeight: "600",
    color: "#333",
    marginBottom: "8px",
  },
  mapSubText: {
    fontSize: "14px",
    color: "#666",
    textAlign: "center",
    marginBottom: "20px",
  },
  mapFrame: {
    width: "100%",
    height: "250px",
    backgroundColor: "#e9ecef",
    borderRadius: "6px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  mapContent: {
    textAlign: "center",
  },
  mapPin: {
    fontSize: "32px",
    marginBottom: "10px",
  },
  mapAddress: {
    fontSize: "14px",
    color: "#333",
    fontWeight: "500",
  },
  quickContact: {
    backgroundColor: "#f8f9fa",
    padding: "20px",
    borderRadius: "8px",
    border: "1px solid #e9ecef",
  },
  contactButtons: {
    display: "flex",
    gap: "15px",
    marginTop: "15px",
  },
  contactButton: {
    backgroundColor: "#001e78",
    color: "white",
    padding: "12px 24px",
    borderRadius: "6px",
    textDecoration: "none",
    fontSize: "14px",
    fontWeight: "500",
    transition: "background-color 0.3s ease",
    textAlign: "center",
    flex: 1,
  },
};

// Hover efektleri
styles.contactButton = {
  ...styles.contactButton,
  ":hover": {
    backgroundColor: "#004494",
  },
};

styles.link = {
  ...styles.link,
  ":hover": {
    textDecoration: "underline",
  },
};

export default Iletisim;